import { getHumanResourceIndex, postJobList, postJobDetail,postBottomDetail } from "@/api";

const actions = {
	async getHumanResourceData({commit}){
		let res = await getHumanResourceIndex()
			commit('SAVE_HUMAN_DATA',res)
	},
	async postJobListData({commit},{currentPage,pageSize}){
		let res = await postJobList({page:currentPage,page_size:pageSize})
			commit('SAVE_JOB_DATA',res)
	},
	async postJobDetailData({commit},params){
		let res = await postJobDetail(params)
			commit('SAVE_JOB_DETAIL_DATA',res)
	},
	async postBottomDetail({commit},id){
		let res = await postBottomDetail({id})
			commit('SAVE_JOB_BOTTOM_DATA',res)
	}

}

const mutations = {
	SAVE_HUMAN_DATA(state,data){
		state.leader = data.data.leader
		state.job = data.data.job
		state.human = data.data.human
	},
	SAVE_JOB_DATA(state,data){
		state.jobData = data.data
		
	},
	SAVE_JOB_DETAIL_DATA(state,data){
		state.jobDetailData = data.data
		
	},
	SAVE_JOB_BOTTOM_DATA(state,data){
		state.jobBottomData = data.data
	},
	clear(state) {
		state.jobDetailData = '',
		state.jobBottomData = ''
	},

}

const state = {
  leader: [],
  job: [],
  human: [],
  jobData: {},
  jobDetailData: {},
  jobBottomData:{}
};

const getters = {};

export default {
  actions,
  mutations,
  state,
  getters,
};
